import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faSuperscript } from '@fortawesome/pro-light-svg-icons';

export type ProLightSuperscriptProps = IconComponentProps;

export const ProLightSuperscript = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightSuperscriptProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faSuperscript}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faSuperscript}
    />
  );
};

ProLightSuperscript.displayName = 'ProLightSuperscript';
